import { Component, OnInit } from '@angular/core';
import { CommonFieldsService } from '../common-fields.service';
import { Observable } from 'rxjs';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
// import { GoogleMapComponent } from 'app/core/google-map/google-map.component';
import { ApplicantService } from '../applicant.service';
import { environment as ENV } from '../../../environments/environment'
// import { LandRecordsService } from '../bhoomi/land-records.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { saveAs } from "file-saver/dist/FileSaver";


@Component({
  selector: 'wl-geo-mapping',
  templateUrl: './geo-mapping.component.html',
  styles: [],
  // providers: [LandRecordsService]
})
export class GeoMappingComponent implements OnInit {

  crops: Observable<any>;
  geoMappingForm: UntypedFormGroup;
  coordArray: any;
  showReport: any;
  docPath: any;
  s3Url: any;
  isLoading: Boolean = false;
  showList: boolean = false;
  disablesatsureform: boolean = false;
  geodata: any = [];
  // kccNewUat: string = environment.kccNewUat
  imageBufferLink: string;
  imageBase64: any;
  constructor(
    private common: CommonFieldsService,
    private fb: UntypedFormBuilder,
    private dialog: MatDialog,
    private applicant: ApplicantService,
    // private bhoomi: LandRecordsService,
    private snackbar: MatSnackBar,
    private http: HttpClient,
  ) {
    this.geoMappingForm = this.fb.group({
      farmerName: ['', Validators.required],
      cropName: ['', Validators.required],
      coordinates: [''],
    })
    this.s3Url = ENV.imageUrl;
  }

  ngOnInit() {



    this.isLoading = true;
    // this.applicant.satSureLogin().subscribe(result => {
    //   console.log(result, "Login satsure");
    //   if (result && result.success == true) {
    //     sessionStorage.setItem("satTkn", result.result.token);
    //   }
    //   if (result && result.result && result.result.token) {
    //     this.applicant.getCropsSatSure().subscribe(res => {
    //       console.log(res, 'ressssssssssssssssssssss');
    //       this.crops = res.result.data;
    //       if (res) {
    //         this.isLoading = false;
    //         this.showList = true;
    //       }
    //     });
    //   }
    // })


    this.applicant.getEverything().subscribe(result => {
      let data = result && result.docs && result.docs.assets && result.docs.assets.satSure && result.docs.assets.satSure.input ? result.docs.assets.satSure.input : "";
      if (data) {
        data.map(res => {
          // if (res && res.wlOutput && res.wlOutput.report) {
          //   let file = res.wlOutput.report
          //   this.geodata.push(file)
          // }

          if (res && res.wlOutput && res.wlOutput.reportUrl && res.wlOutput.reportUrl.referenceId) {
            let file = res.wlOutput.reportUrl.referenceId
            this.geodata.push(file)
          }
        })
      }

    })




    /*  this.bhoomi.get().subscribe(resp => {
        this.geoMappingForm.patchValue(
         {
           farmerName: resp.result.profile.name ? resp.result.profile.name : ''
         });
       if (resp && resp.result && resp.result.docs && resp.result.docs.assets && resp.result.docs.assets.satSure && resp.result.docs.assets.satSure.input) {
         console.warn(resp.result.docs.assets.satSure.input, "sat sure input");
         let lastArray = resp.result.docs.assets.satSure.input.length - 1;
         if (resp.result.docs.assets.satSure.input[lastArray] && resp.result.docs.assets.satSure.input[lastArray].wlOutput && resp.result.docs.assets.satSure.input[lastArray].wlOutput.reportUrl) {
           console.log(resp.result.docs.assets.satSure.input[lastArray].wlOutput.reportUrl);
           this.docPath = resp.result.docs.assets.satSure.input[lastArray].wlOutput.reportUrl;
           this.showReport = true;
         }
 
         // https://s3.ap-south-1.amazonaws.com/ubi-whatsloan.com/satSure-farm-report/61a8089242668.pdf
 
       }
     }); */

  }

  downloadPdf(index) {
    let link = this.geodata[index]
    const linkSource = link
    const downloadLink = document.createElement("a");
    // const fileName = `GeomappingReport-${index}.pdf`;
    const label = `GeomappingReport-${index}`
    this.imageBufferLink = `/file/SATSURE/${link}`
    this.applicant.getImage(this.imageBufferLink).subscribe(resp => {
      console.log(resp)
      if (resp && resp.result && resp.result.imageData && resp.result.imageData.data) {
        this.imageBase64 = resp.result.imageData.data;
        // this.imageBase64 = data.result.imageData.data
        downloadLink.href = 'data:application/pdf;base64,' + this.imageBase64

        let fileName = "LandRecord.pdf";
        downloadLink.download = `GeomappingReport-${index}.pdf`;
        downloadLink.click();
      }

    },err=>{
      console.log(err)
    })

    // downloadLink.href = `${this.kccNewUat}/static/${linkSource}`;

    // this.http.get( downloadLink.href, { responseType: "arraybuffer" }).subscribe(
    //   pdf => {
    //     const blob = new Blob([pdf], { type: "application/pdf" });
    //     const fileName = `${label}.pdf`;
    //     saveAs(blob, fileName);
    //   },
    //   err => {
    //     console.log("err->", err);
    //   }
    // );
  }

  // downloadPdf(index) {
  //   let fileBase64 = this.geodata[index]
  //   const linkSource = 'data:application/pdf;base64,' + fileBase64;
  //   const downloadLink = document.createElement("a");
  //   const fileName = "GeoMappingReport.pdf";

  //   downloadLink.href = linkSource;
  //   downloadLink.download = fileName;

  //   downloadLink.click();


  // }

  // openDialog() {
  //   console.log("open dialog clicked");
  //   const dialogRef = this.dialog.open(GoogleMapComponent, { width: '600px;' });
  // dialogRef.afterClosed().subscribe(result => {
  //   if (result) {
  //     console.log('Result Location: ', result);
  //     this.geoMappingForm.patchValue({ coordinates: result.address });
  //   } else {
  //     console.log('Address: ', 'Address not selected');
  //   }
  // });
  // }

  // openDialog() {
  //   const dialogRef = this.dialog.open(GoogleMapComponent);
  //   dialogRef.afterClosed().subscribe(result => {
  //     if (result) {
  //       this.coordArray = result;
  //       console.log("coordarray", this.coordArray);
  //       console.log(typeof (result), "Result on close gmap");
  //       console.log("result arry is", result, JSON.stringify(result));
  //       this.geoMappingForm.patchValue({ coordinates: JSON.stringify(result) });

  //     } else {
  //       console.log('Address: ', 'Address not selected');
  //     }
  //   });
  // }

  submitForm() {
    this.applicant.satSureLogin().subscribe(result => {
      console.log(result, "Login satsure");
      if (result && result.result && result.result.token) {
        sessionStorage.setItem("satTkn", result.result.token);
      }
      if (result && result.result && result.result.userId) {
        sessionStorage.setItem("satId", result.result.userId);
      }
    })

    let input = this.geoMappingForm.getRawValue();

    console.log(input);
    console.log(typeof (input.coordinates));
    // console.log(input.coordinates.replace(/^["'](.+(?=["']$))["']$/, '$1'));
    // debugger
    console.log(this.coordArray, "Coord array");
    let obj = this.coordArray;
    console.log(obj)
    let array1 = new Array;
    array1.push(obj.A.lng);
    array1.push(obj.A.lat);
    console.log(array1);
    let array2 = new Array;
    array2.push(obj.B.lng);
    array2.push(obj.B.lat);
    let array3 = new Array;
    array3.push(obj.C.lng);
    array3.push(obj.C.lat);
    let array4 = new Array;
    array4.push(obj.D.lng);
    array4.push(obj.D.lat);
    let firstArray = new Array;
    firstArray.push(array1);
    firstArray.push(array2);
    firstArray.push(array3);
    firstArray.push(array4);
    firstArray.push(array1);
    console.log(firstArray);
    let secondArray = new Array;
    secondArray.push(firstArray);
    let finalArray = new Array;
    finalArray.push(secondArray);


    // console.log(JSON.parse(this.coordArray));
    let appId = sessionStorage.getItem('applicantId');
    console.log(JSON.stringify(finalArray), "finalArray");

    let newId = appId.slice(0, 4);
    let newId2 = appId.slice(appId.length - 5, appId.length - 1);
    const myArray = new Uint32Array(1);
    let rand = crypto.getRandomValues(myArray);
    let farmId = newId + newId2 + rand;

    let custId = sessionStorage.getItem('applicantId') + '_' + 'ubifintech';
    let data = {
      "farmId": farmId,
      "farmBoundary": {
        "type": "MultiPolygon",
        "coordinates": finalArray
      },
      "farmName": input.farmerName,
      "cust_id": custId,
      "cropName": input.cropName
    }

    // "coordinates": [[[[79.79489844292402,14.075740969661155],[79.79627408087254,14.075578364860164],[79.79597132652997,14.073692140713307],[79.79501511901617,14.07433931247671],[79.79489844292402,14.075740969661155]]]]


    this.applicant.satSureFarm(JSON.stringify(data)).subscribe(result => {
      console.log(result);
      // this.snackbar.open(result.result.message,'OK',{duration:3000})
      if (result && result.success == true) {
        this.applicant.satSureFarmSave(data).subscribe(result => {
          console.log(result);
          this.snackbar.open(result.message, 'OK', { duration: 3000 })
        })
      }
    })

  }



}
